import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { adminApi, formatApiError } from "@/context/AuthContext";

// Admin > Agenda: the AI files the events without a category (concert, festival…), with live progress
export const EventClassify = () => {
  const qc = useQueryClient();
  const [st, setSt] = useState(null);

  const refresh = async () => {
    const { data } = await adminApi.get("/admin/events/classify");
    setSt(data);
    return data;
  };

  useEffect(() => { refresh().catch(() => {}); }, []);

  useEffect(() => {
    if (!st?.running) return undefined;
    const t = setInterval(async () => {
      try {
        const data = await refresh();
        if (!data.running) {
          qc.invalidateQueries({ queryKey: ["/events"] });
          toast.success(data.missing ? `Classement terminé : ${data.missing} événement(s) restent sans catégorie.` : "Tous les événements ont une catégorie.");
        }
      } catch { /* keep polling */ }
    }, 3000);
    return () => clearInterval(t);
  }, [st?.running, qc]);

  const start = async () => {
    try {
      setSt((await adminApi.post("/admin/events/classify")).data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  if (!st || (!st.running && !st.missing && !st.error)) return null;
  return (
    <div className="flex flex-wrap items-center gap-4 mb-6" data-testid="event-classify">
      <button type="button" onClick={start} disabled={st.running} data-testid="event-classify-btn"
        className="inline-flex items-center gap-2 border border-white/30 text-white uppercase text-xs font-bold tracking-[0.15em] px-4 py-2.5 hover:border-white transition-colors disabled:opacity-50">
        {st.running ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Classer les événements avec l'IA
      </button>
      <p className="text-sm text-zinc-300" data-testid="event-classify-progress">
        {st.running ? `${st.done} / ${st.total} événements classés…` : `${st.missing} événement(s) sans catégorie`}
      </p>
      {st.error && <p className="text-sm text-yellow-400" data-testid="event-classify-error">{st.error}</p>}
    </div>
  );
};
